import PaginationButtonRow from '@shared/components/core/button/PaginationButtonRow';
import SubSectionRow from '@shared/components/core/headers/SubSectionRow';
import SearchField from '@shared/components/core/search/SearchField';
import { StickyFooterStretch } from '@shared/components/core/structure/CommonBodyLayoutStyles';
import SplashLoader from '@shared/components/loading/SplashLoader';
import { useLicenseKeyFetching } from '@shared/hooks/useLicenseKeyFetching';
import useLicenseKeySearch from '@shared/hooks/useLicenseKeySearch';
import { useTranslation } from 'react-i18next';
import LicenseKeyActionRow from './LicenseKeyActionRow';
import LicenseKeyEmptyBanner from './LicenseKeyEmptyBanner';

export default function LicenseKeyPageContent() {
    const { t } = useTranslation();
    const { isLoading } = useLicenseKeyFetching(); //initialize
    const licenseKeySearch = useLicenseKeySearch(); //search
    const hasResults = licenseKeySearch.results.length > 0;

    if (isLoading) return <SplashLoader />;
    return (
        <>
            <SearchField
                value={licenseKeySearch.searchQuery}
                onChange={(e) => licenseKeySearch.handleSearchQueryChange(e.target.value)}
                onClear={() => licenseKeySearch.handleSearchQueryChange('')}
            />
            {hasResults && <SubSectionRow title={t('common:results')} variant="small"></SubSectionRow>}
            {hasResults ? (
                licenseKeySearch.results.map((licenseKey) => (
                    <LicenseKeyActionRow licenseKey={licenseKey} key={licenseKey.id} />
                ))
            ) : (
                <LicenseKeyEmptyBanner />
            )}
            <StickyFooterStretch $visuallyHide={licenseKeySearch.results.length == 0}>
                <PaginationButtonRow
                    onNext={licenseKeySearch.handleNext}
                    onPrevious={licenseKeySearch.handlePrevious}
                    disableNext={!licenseKeySearch.showNext}
                    disablePrevious={!licenseKeySearch.showPrevious}
                />
            </StickyFooterStretch>
        </>
    );
}
